import React from "react";
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

//Types
import { SvgIconProps } from "@mui/material";

function Photo360Icon(props: SvgIconProps) {
  return <PhotoCameraIcon {...props}/>;
}

export default Photo360Icon;
